import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    const $navMenu = $('.header-nav .nav-menu');
    addAction('stickyHeaderShow', () => {
        $navMenu.removeClass('nav-menu--responsive');
    });

    addAction('stickyHeaderHide', () => {
        $navMenu.addClass('nav-menu--responsive');
    });

    addAction('showNavMenuOverlay', () => {
        $navMenu.find('.nav-menu__toggle-label').text('Close');
    });

    addAction('hideNavMenuOverlay', () => {
        $navMenu.find('.nav-menu__toggle-label').text('Menu');
    });
});
